/**
 * Before/After examples for the Photo Enhance hero, one per enhance type.
 *
 * Empty until real outputs from the production model exist (generate 3–5 photos
 * per type with the real pipeline, see docs/template-creation-guide.md). Never
 * fake an example by blurring a photo: the hero stays hidden while this is empty.
 * Put the image files in `public/img/enhance/`.
 */
import type { EnhanceType } from '@loomia/shared';

export interface EnhanceExample {
  type: EnhanceType;
  before: string;
  after: string;
}

// Real outputs from the production model (Kie.ai nano-banana-edit with the
// server's own wording, 2026-10-24). Inputs: an AI-generated portrait saved at
// low quality, and an AI-generated wedding photo aged into a damaged B&W print.
export const ENHANCE_EXAMPLES: readonly EnhanceExample[] = [
  { type: 'auto', before: '/img/enhance/auto-before.webp', after: '/img/enhance/auto-after.webp' },
  { type: 'restore_colorize', before: '/img/enhance/restore-colorize-before.webp', after: '/img/enhance/restore-colorize-after.webp' },
];
